module.exports = __webpack_public_path__ + "img/key_w.16b56886.svg";